module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "calibre1",
    attrs: {
      "id": "pgepubid00005"
    }
  }, [_c('a', {
    staticClass: "calibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "QUOTATIONS"
    }
  }), _c('a', {
    staticClass: "calibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0002#toc"
    }
  }, [_vm._v("QUOTATIONS.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('i', {
    staticClass: "calibre5"
  }, [_vm._v("A man, to succeed, must possess the necessary equanimity of temperament to conceive an idea, the capacity to form it into some tangible shape, the ingenuity to put it into practical operation, the ability to favorably impress others with its merits, and the")]), _vm._v(" "), _c('span', {
    staticClass: "smcap1"
  }, [_vm._v("power")]), _vm._v(" "), _c('i', {
    staticClass: "calibre5"
  }, [_vm._v("of")]), _vm._v(" "), _c('span', {
    staticClass: "smcap1"
  }, [_vm._v("will")]), _vm._v(" "), _c('i', {
    staticClass: "calibre5"
  }, [_vm._v("that is absolutely necessary to force it to success.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('a', {
    staticClass: "pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "Page_9",
      "title": "[9]"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "sig"
  }, [_vm._v("—"), _c('span', {
    staticClass: "smcap1"
  }, [_vm._v("Thomas A. Scott")]), _vm._v("."), _c('br', {
    staticClass: "calibre6"
  })]), _vm._v(" "), _c('p', {
    staticClass: "c"
  }, [_vm._v("Labor rids us of three evils.—Tediousness, Vice and Poverty.")]), _vm._v(" "), _c('p', {
    staticClass: "sig"
  }, [_vm._v("—"), _c('span', {
    staticClass: "smcap1"
  }, [_vm._v("Carlyle")]), _vm._v("."), _c('br', {
    staticClass: "calibre6"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("\""), _c('i', {
    staticClass: "calibre5"
  }, [_vm._v("Never start upon an undertaking until you are sure it is practicable and ought to be done, and then let nothing stand long in the way of accomplishing that undertaking. It is better to deserve success than to have it; few deserve it who do not attain it.")]), _vm._v("\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("\""), _c('i', {
    staticClass: "calibre5"
  }, [_vm._v("There is no failure in this country for those whose personal habits are good, and who follow some honest calling industriously, unselfishly, and purely. If one desires to succeed, he must pay the price")]), _vm._v("—"), _c('span', {
    staticClass: "smcap1"
  }, [_vm._v("work")]), _vm._v("!\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('i', {
    staticClass: "calibre5"
  }, [_vm._v("In order to succeed, a man must have a purpose fixed, then let his motto be")]), _vm._v(" "), _c('span', {
    staticClass: "smcap1"
  }, [_vm._v("victory or death")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "sig"
  }, [_vm._v("—"), _c('span', {
    staticClass: "smcap1"
  }, [_vm._v("Henry Clay")]), _vm._v("."), _c('br', {
    staticClass: "calibre6"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("\""), _c('i', {
    staticClass: "calibre5"
  }, [_vm._v("Be liberal but cautious; enterprising but careful.")]), _vm._v("\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("\""), _c('i', {
    staticClass: "calibre5"
  }, [_vm._v("Our greatest glory is not in never falling, but in rising every time we fall.")]), _vm._v("\""), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('br', {
    staticClass: "calibre6"
  })]), _vm._v(" "), _c('div', {
    staticClass: "poem"
  }, [_c('div', {
    staticClass: "stanza"
  }, [_c('em', {
    staticClass: "i"
  }, [_c('i', {
    staticClass: "calibre5"
  }, [_vm._v("Fail!—Fail?")]), _c('br', {
    staticClass: "calibre6"
  })]), _vm._v(" "), _c('span', {
    staticClass: "i1"
  }, [_c('i', {
    staticClass: "calibre5"
  }, [_vm._v("In the lexicon of youth, which Fate reserves for a bright manhood, there is no such word")]), _c('br', {
    staticClass: "calibre6"
  })]), _vm._v(" "), _c('span', {
    staticClass: "i2"
  }, [_vm._v("As—fail!")])])]), _vm._v(" "), _c('p', {
    staticClass: "sig"
  }, [_vm._v("—\""), _c('span', {
    staticClass: "smcap1"
  }, [_vm._v("Richelieu")]), _vm._v(".\"")]), _vm._v(" "), _c('p', {
    staticClass: "c"
  }, [_vm._v("Benjamin Franklin has truly said: The road to wealth is as plain as the road to mill.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('a', {
    staticClass: "pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "Page_10",
      "title": "[10]"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5e34d0c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0005.vue
// module id = 69
// module chunks = 0